import { DateRange } from 'react-day-picker';

export const sessionKeys = {
  all: ['sessions'] as const,
  lists: () => [...sessionKeys.all, 'list'] as const,
  byCoach: (coachIds: string[], dateRange?: DateRange) =>
    [...sessionKeys.lists(), { coachIds, dateRange }] as const,
  detail: (id: string) => [...sessionKeys.all, 'detail', id] as const,
  status: (id: string) => [...sessionKeys.all, 'status', id] as const,
};
